import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';

import { UserNotificationVm } from '../../../shared/generated/Administration/Models/User/Notifications/UserNotificationVm';
import { SecurityService } from '../../../core/security/security.service';
import { SystemMessageService } from '../../../core/system-message/system-message-service';
import { GlobalVariablesService } from '../../../services/global-variables.service';

@Component({
    selector: 'pcg-user-notifications',
    templateUrl: './user-notifications.component.html',
    styleUrls: ['./user-notifications.component.scss'],
    standalone: false
})
export class UserNotificationComponent implements OnInit {

	@Input() id: number;

	formGroup = UserNotificationVm.Form;
	model = UserNotificationVm.GetModel(this.formGroup);
	model$: Observable<UserNotificationVm>;
	isAdmin = false;
	isSubscribedToAll = false;
	fullName: string;

	// Font awesome
    faIconName = { faInfoCircle };

	constructor(
		private httpClient: HttpClient
		, private sec: SecurityService
		, private gvs: GlobalVariablesService
		, private messageService: SystemMessageService
		, private activatedRoute: ActivatedRoute
	) { }

	ngOnInit() {
		this.addSecuritySubscription();
		if (this.id == null) { this.id = this.activatedRoute.snapshot.params.id; }

		this.model$ = this.httpClient
			.get(`api/Administration/Users/GetUserNotifications/${this.id}`)
			.pipe(tap((mf: any) => { this.formGroup.patchValue(mf); }));
		this.getFullName();
	}

	addSecuritySubscription() {	this.sec.security$.subscribe(() => { this.isAdmin = this.sec.hasAccess(o => o.adminFeatures); }); }

	subscribeAll() {
		if (this.isAdmin) {
			if (this.isSubscribedToAll) {
				this.model.dailyCount = true;
				this.model.missedDailyCount = true;
				this.model.businessDaysReminder = true;			
			} else {
				this.model.dailyCount = false;
				this.model.missedDailyCount = false;
				this.model.businessDaysReminder = false;
			}
			this.saveForm();
		}
	}

	saveForm() { 
		this.httpClient.post("api/Administration/Users/SaveUserNotifications", this.formGroup.getRawValue())
			.subscribe((sm: any) => { this.messageService.setSystemMessage(sm.message, sm.messageClass); });
	}

	getFullName() {
		this.httpClient.get(`api/Administration/Users/GetUser?id=${this.id}`)
			.subscribe((user: any) => { 
				this.fullName = user?.fullName; 
				this.gvs.userName.set(user?.fullName);
			}
        );
	}
}